import axios from "axios"
import { LOCAL_TOKEN } from "../utils/storage"

export const getUtilsActionPlanApi = (params) => {
  let url = "action-plans/create?q="
  if (params.actionPlanCreateIa) {
    url += `&action_plan_create_ia=${params.actionPlanCreateIa}`
  }
  if (params.searchByIdMeasure) {
    url += `&searchByIdMeasure=${params.searchByIdMeasure}`
  }
  if (params.searchByIdDivisionAmbassadors) {
    url += `&searchByIdDivisionAmbassadors=${params.searchByIdDivisionAmbassadors}`
  }
  if (params.id_ambassador_profile_filter) {
    url += `&id_ambassador_profile_filter=${params.id_ambassador_profile_filter}`
  }
  if (params.dimensions) {
    for (let i = 0; i < params.dimensions.length; i++) {
      url += `&dimensions[${i}][dimension_name]=${[
        params.dimensions[i].dimension_name,
      ]}`
    }
  }

  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    signal: params.signal,
  })
}

export const saveActionPlanApi = (params) => {
  let url = "action-plans/"
  if (params.id) {
    url = `action-plans/${params.id}`
    params._method = "PUT"
    delete params.id
  }
  if (params.id_recommendation === null) {
    delete params.id_recommendation
  }
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params,
    url: `${process.env.API_URL + url}`,
  })
}

export const getUtilsRecommendationApi = (params) => {
  let url = "recommendations/create?q="
  if (params.id_survey) {
    url += `&id_survey=${params.id_survey}`
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

export const getActionPlansWithIa = (params) => {
  const { id_dimension, id_company,id_measure,id_division,id_dimension_parent,result,regenerate } = params;
  const queryParams = [];

  if (id_dimension) {
    queryParams.push(`id_dimension=${id_dimension}`);
  }
  if (id_company) {
    queryParams.push(`id_company=${id_company}`);
  }
  if (id_measure) {
    queryParams.push(`id_measure=${id_measure}`);
  }
  if (id_division) {
    queryParams.push(`id_division=${id_division}`);
  }
  if (id_dimension_parent) {
    queryParams.push(`id_dimension_parent=${id_dimension_parent}`);
  }
  if (result) {
    queryParams.push(`result=${result}`);
  }
  if (regenerate) {
    queryParams.push(`regenerate=${regenerate}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}action-plans/ia${queryString}`,
  });
};

export const getSuggestionsForAmbassadorDashboard = (data) => {
  return axios.request({
    method: "POST",
    headers: { 
      "Authorization": `Bearer ${LOCAL_TOKEN()}`,
      "Content-Type": "application/json" // Especificamos el tipo de contenido como JSON
    },
    url: `${process.env.API_URL}action-plans/dashboard/suggestions`,

    data: data // Pasamos los datos en el cuerpo de la solicitud
  });
};

export const getDivisionsForAmbassadorDashboard = (params) => {
  const { id_ambassador} = params;
  const queryParams = [];

  if (id_ambassador) {
    queryParams.push(`id_ambassador=${id_ambassador}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}action-plans/dashboard/divisions${queryString}`,
  });
};

export const saveRecommendationApi = (params) => {
  let url = "recommendations/"
  if (params.id) {
    url = `recommendations/${params.id}`
    params._method = "PUT"
    delete params.id
  }
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params,
    url: `${process.env.API_URL + url}`,
  })
}

export const deleteRecommendationApi = (params) => {
  const url = `recommendations/${params.id}`
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}
export const getMeasuresActionPlan = (params) => {
  let url = "action-plans/measures?q="
  if (params.searchByIdMeasure) {
    url += `&searchByIdMeasure=${params.searchByIdMeasure}`
  }
  if (params.searchByIdDivisionAmbassadors) {
    url += `&searchByIdDivisionAmbassadors=${params.searchByIdDivisionAmbassadors}`
  }
  if (params.id_ambassador_profile_filter) {
    url += `&id_ambassador_profile_filter=${params.id_ambassador_profile_filter}`
  }
  if (params.dimensions) {
    for (let i = 0; i < params.dimensions.length; i++) {
      url += `&dimensions[${i}][dimension_name]=${[
        params.dimensions[i].dimension_name,
      ]}`
    }
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })


  
}




export const getLastMeasureOfficialized = (params) => {
  const { id_ambassador} = params;
  const queryParams = [];

  if (id_ambassador) {
    queryParams.push(`id_ambassador=${id_ambassador}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}action-plans/ia/measure${queryString}`,
  });
};




//is_new_pda_ia_notification
export const updatePdaIaNotification = () => {
  return axios.request({
    method: "POST",
    headers : { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}users/is_new_pda_ia_notification`,
    data: []

  }) 
}